import { Color } from '@coast/schemas';

export const MAX_TAG_LENGTH = 64;

export const COLORS: Color[] = [
  Color.tagPink,
  Color.tagYellow,
  Color.tagDewGreen,
  Color.tagCoastGreen,
  Color.tagCoolBlue,
  Color.tagPurple,
  Color.tagGray,
];

export function generateTagColor(total: number): Color {
  return COLORS[total % COLORS.length];
}
